class Task {
  constructor (name, text, list) {
    this.name = name
    this.text = text
    this.list = list
    this.done = false
    this.id = ~~(Math.random() * 1000000)
  }
}

export default {
  state: {
    tasks: [{
      name: 'First task',
      text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Blanditiis fugiat, voluptatem vel praesentium at nihil non rerum obcaecati pariatur adipisci. Autem sapiente, quasi non facere sint est sit fugit exercitationem!',
      list: 111,
      done: false,
      id: ~~(Math.random() * 1000000)
    },
    {
      name: 'Second task',
      text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Blanditiis fugiat, voluptatem vel praesentium at nihil non rerum obcaecati pariatur adipisci. Autem sapiente, quasi non facere sint est sit fugit exercitationem!',
      list: 111,
      done: false,
      id: ~~(Math.random() * 1000000)
    },
    {
      name: 'Third task',
      text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Blanditiis fugiat, voluptatem vel praesentium at nihil non rerum obcaecati pariatur adipisci. Autem sapiente, quasi non facere sint est sit fugit exercitationem!',
      list: 111,
      done: false,
      id: ~~(Math.random() * 1000000)
    },
    {
      name: 'Fourth task',
      text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Blanditiis fugiat, voluptatem vel praesentium at nihil non rerum obcaecati pariatur adipisci. Autem sapiente, quasi non facere sint est sit fugit exercitationem!',
      list: 111,
      done: false,
      id: ~~(Math.random() * 1000000)
    },
    {
      name: 'First task',
      text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Blanditiis fugiat, voluptatem vel praesentium at nihil non rerum obcaecati pariatur adipisci. Autem sapiente, quasi non facere sint est sit fugit exercitationem!',
      list: 222,
      done: false,
      id: ~~(Math.random() * 1000000)
    },
    {
      name: 'Second task',
      text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Blanditiis fugiat, voluptatem vel praesentium at nihil non rerum obcaecati pariatur adipisci. Autem sapiente, quasi non facere sint est sit fugit exercitationem!',
      list: 444,
      done: false,
      id: ~~(Math.random() * 1000000)
    },
    {
      name: 'Third task',
      text: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Blanditiis fugiat, voluptatem vel praesentium at nihil non rerum obcaecati pariatur adipisci. Autem sapiente, quasi non facere sint est sit fugit exercitationem!',
      list: 444,
      done: true,
      id: ~~(Math.random() * 1000000)
    }]
  },
  mutations: {
    createTask (state, payload) {
      state.tasks.push(payload)
    },
    deleteTaskById (state, payload) {
      state.tasks = state.tasks.filter(elem => elem.id !== payload)
    },
    deleteTasksByList (state, payload) {
      state.tasks = state.tasks.filter(elem => elem.list !== payload)
    },
    toggleDone (state, payload) {
      state.tasks.find(elem => {
        if (elem.id === payload) {
          elem.done = !elem.done
          return true
        }
      })
    },
    editTask (state, {name, text, id}) {
      let task = state.tasks.find(elem => elem.id === id)
      task.name = name
      task.text = text
    },
    loadTasks (state, payload) {
      state.tasks = payload
    }
  },
  actions: {
    deleteTaskById ({commit, dispatch}, payload) {
      commit('deleteTaskById', payload)
      dispatch('uploadTasksToLocalStorage')
    },
    createTask ({commit, dispatch}, {name, text, list}) {
      let task = new Task(name, text, list)
      commit('createTask', task)
      dispatch('uploadTasksToLocalStorage')
    },
    deleteTasksByList ({commit, dispatch}, payload) {
      commit('deleteTasksByList', payload)
      dispatch('uploadTasksToLocalStorage')
    },
    toggleDone ({commit, dispatch}, payload) {
      commit('toggleDone', payload)
      dispatch('uploadTasksToLocalStorage')
    },
    editTask ({commit, dispatch}, payload) {
      commit('editTask', payload)
      dispatch('uploadTasksToLocalStorage')
    }
  },
  getters: {
    tasks (state) {
      return state.tasks
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/tasks.js